module.exports = __webpack_public_path__ + "img/qrcode8.bc7ccfe6.png";